/* NW soevnguide: gør mailopsamlingen synlig. Tilfoejet 31-08-2026.

   PROBLEMET, maalt: guiden bad reelt aldrig om en mail. Der laa kun et lille
   graat tekstlink, "Faa den paa mail", nede i linjen sammen med favoritter.
   Klaviyo-metrikken "Anmodet sengeanbefaling" har 7 haendelser I ALT siden juni.

   Hvorfor det er den stoerste aabne vaerdi paa siden: trafikken er betalt, de
   fleste koeber ikke i dag, og uden en mail er pengene tabt i det sekund fanen
   lukkes. Med en mail er de en liste vi kan saelge til i oktober og til jul.

   VI BYGGER IKKE EN NY OPSAMLING. Overlayet bag #nw-email-link findes og virker:
   det bruger Klaviyos client-REST med revision 2025-01-15, ikke klaviyo.js, som
   sluger kald uden cookiesamtykke. Denne fil goer kun spoergsmaalet synligt og
   klikker det eksisterende link. Ét sted opsamler, alle andre henviser.

   PLACERING: sidst i .match, altsaa lige efter anbefalingen og begrundelsen.
   Det er Emma Sleeps logik, bare paa vores side af resultatet: spoerg naar du
   LIGE har givet noget, ikke foer. Blokken arver .match's order, saa den
   flytter med hvis raekkefoelgen aendres igen.

   TEKSTEN LOVER KUN DET FLOWET FAKTISK GOER. Flow TAMf7L hedder "DK -
   Sengeguide Anbefaling" og sender anbefalingen, ikke hele det sammensatte
   saet. Derfor staar der anbefaling. Skal den sende saettet, skal flowet
   aendres foerst, ikke teksten.

   ESCAPING-FAELDE, fanget under test: foerste version skrev skriftnavnet som
   font-family:\\'Cormorant Garamond\\' inde i en enkeltciteret JS-streng. I
   GraphQL-blokstrenge er backslash BOGSTAVELIG, saa filen fik en escaped
   backslash efterfulgt af et anfoerselstegn, som lukkede strengen for tidligt.
   Hele filen kunne ikke parses. Brug dobbelte anfoerselstegn indeni i stedet. */
(function(){
  'use strict';

  function stil(){
    if(document.getElementById('nw-sg-mail-css')){ return; }
    var s = document.createElement('style');
    s.id = 'nw-sg-mail-css';
    s.textContent =
      '#nwsg .nwmail{margin-top:20px;border:1px solid var(--line);background:var(--creamlt);border-radius:6px;padding:16px 18px;text-align:center}' +
      '#nwsg .nwmail-h{font-family:"Cormorant Garamond",serif;font-size:20px;line-height:1.2;color:var(--ink);margin-bottom:5px}' +
      '#nwsg .nwmail-p{font-size:13px;line-height:1.5;color:var(--stone);margin-bottom:12px}' +
      '#nwsg .nwmail-b{display:inline-flex;align-items:center;gap:7px;cursor:pointer;border:1px solid var(--sage);background:#fff;color:var(--sageDark);' +
        'border-radius:30px;padding:9px 20px;font-family:inherit;font-size:13.5px;font-weight:500;transition:.18s}' +
      '#nwsg .nwmail-b:hover{background:var(--sage);color:#fff}' +
      '#nwsg .nwmail-b svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;flex-shrink:0}' +
      '#nwsg .nwmail-b:hover svg{stroke:#fff}' +
      '@media(max-width:480px){#nwsg .nwmail{padding:14px 15px}#nwsg .nwmail-h{font-size:18px}}';
    document.head.appendChild(s);
  }

  var KUVERT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>';

  function byg(){
    try{
      var match = document.querySelector('#nwsg .match');
      if(!match){ return; }

      /* Findes det eksisterende opsamlingslink ikke, viser vi ingenting.
         Hellere ingen knap end en knap der ikke goer noget. */
      var link = document.getElementById('nw-email-link');
      if(!link){
        var gl = document.getElementById('nwmail');
        if(gl){ gl.remove(); }
        return;
      }

      stil();
      if(document.getElementById('nwmail')){ return; }

      var b = document.createElement('div');
      b.id = 'nwmail';
      b.className = 'nwmail';
      b.innerHTML =
        '<div class="nwmail-h">Vil du tænke over det?</div>' +
        '<div class="nwmail-p">Vi sender din anbefaling, så du kan finde den igen i ro og mag.</div>' +
        '<button type="button" class="nwmail-b">' + KUVERT + '<span>Send min anbefaling</span></button>';

      b.querySelector('.nwmail-b').addEventListener('click', function(){
        try{
          var l = document.getElementById('nw-email-link');
          if(l){ l.click(); }
        }catch(e){}
      });

      match.appendChild(b);
    }catch(e){}
  }

  var hooket = false;
  function hook(){
    if(hooket || typeof window.renderResult !== 'function'){ return; }
    hooket = true;
    var f = window.renderResult;
    window.renderResult = function(){ var r = f.apply(this, arguments); byg(); return r; };
  }

  function start(){ hook(); byg(); }

  start();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  window.addEventListener('load', start);
  setTimeout(start, 1500);
  setTimeout(start, 3500);
})();